import type { EFeatureValue, TFeatureName } from '~/features/feature-flags';
import type { TDevToolbarFormData, TDebugFeature } from '../../models';

import { EFeatureName } from '~/features/feature-flags';
import { ToolbarStorage } from '../ToolbarStorage';
import { EDebugFeature } from '../../models';

export class ToolbarStorageToUiConverter {
  static getInitStates(): TDevToolbarFormData {
    const ffFieldsObj = {} as Record<TFeatureName, EFeatureValue>;
    Object.values(EFeatureName).forEach(
      (name) => (ffFieldsObj[name] = ToolbarStorage.getStorageToolbarField('featureFlags')[name])
    );

    const debugFieldsObj = {} as Record<TDebugFeature, boolean>;
    Object.values(EDebugFeature).forEach(
      (name) => (debugFieldsObj[name] = ToolbarStorage.getDebugValue(name))
    );

    return {
      api: ToolbarStorage.getStorageToolbarField('restEnv') ?? 'auto',
      ...ffFieldsObj,
      ...debugFieldsObj,
    };
  }

  static patch(data: TDevToolbarFormData) {
    (Object.keys(data) as Array<keyof TDevToolbarFormData>).forEach((key) => {
      /** API */
      if (key === 'api') {
        const value = data[key];
        ToolbarStorage.setRestEnv(value === 'auto' ? null : value);
        return;
      }

      /** FF */
      if (Object.values(EFeatureName).includes(key as TFeatureName)) {
        ToolbarStorage.setFeatureFlag({
          name: key as TFeatureName,
          value: data[key] as EFeatureValue,
        });
        return;
      }

      /** Debug */
      if (Object.values(EDebugFeature).includes(key as TDebugFeature)) {
        ToolbarStorage.setDebugFlag({ name: key as TDebugFeature, value: data[key] as boolean });
        return;
      }
    });
  }
}
